import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import messages from '../translate'
import CountSummary from '../SeaLiceStatistic/CountSummary'
import TotalSeaLice from '../SeaLiceStatistic/TotalSeaLice'
import SLSitesInfoTable from '../InfoTable/SLSitesInfoTable'
import WidgetContainer from '../../WidgetContainer'
import Breadcrumbs from '../InfoTable/Breadcrumbs'
import MySitesMap from './MySitesMap'

class MySitesWidget extends Component {
  renderMapView = () => {
    const {
      intl: { formatMessage },
    } = this.props

    return ifWindowWidthLessThan(992) ? null : (
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <WidgetContainer name={`${formatMessage(messages.mapView)}`}>
          <div className="mysites-map">
            <MySitesMap hiddenMarkerInfo />
          </div>
        </WidgetContainer>
      </Grid>
    )
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <div className="my-sites-view">
        <Grid container spacing={2} className="sealice-statistic">
          {this.renderMapView()}
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <CountSummary />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TotalSeaLice />
          </Grid>
        </Grid>
        <WidgetContainer name={formatMessage(messages.siteList)}>
          <Breadcrumbs />
          <SLSitesInfoTable />
        </WidgetContainer>
      </div>
    )
  }
}

export default injectIntl(MySitesWidget)
